import faviconDentHR from "../../../img/Logo.png";

const LogoMark = ({ className }) => {
	return (
		<img src={faviconDentHR} className={`h-9 ${className}`} alt="DentHR" />
	);
};

export default LogoMark;
